// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import dealerRecommendationConfirmModal from './dealer-recommendation-modal';
import dealerRecommendations from './dealer-recommendation';
import facets from './facets';
import hasSearchResults from '../../shared/reducers/has-search-results';
import reportsAccordion from './reports-accordion';
import searchByDropDown from '../../shared/reducers/search-dropdown';
import searchFilters from './search-filters';
import searchQueryString from '../../shared/reducers/search-query-string';
import selectedDealerRecommendations from './checkbox-dealer-recommendation';

export default {
    dealerRecommendationsReducer: combineReducers({
        busyCounter,
        dealerRecommendationConfirmModal,
        dealerRecommendations,
        facets,
        hasSearchResults,
        reportsAccordion,
        searchByDropDown,
        searchFilters,
        searchQueryString,
        selectedDealerRecommendations
    })
};



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/reducers/index.js